'use client';

import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';
import type React from 'react';
import type { SVGProps } from 'react';

import { useFusionTheme } from '../hooks';

import styles from './Icon.module.scss';

type IconVariantProps = VariantProps<typeof iconVariants>;

export interface IconProps extends SVGProps<SVGElement>, IconVariantProps {
  icon: React.FC<React.SVGProps<SVGElement>>;
  className?: string;
}

export const ICON_SIZE_VALUES = {
  sm: styles.sm,
  md: styles.md,
  lg: styles.lg
};

export const ICON_DEFAULT_VALUES = {
  size: 'md'
} as const;

const iconVariants = cva(undefined, {
  variants: {
    size: ICON_SIZE_VALUES
  },
  defaultVariants: {
    size: ICON_DEFAULT_VALUES.size
  }
});

const Icon = ({ icon: IconComponent, size = 'md', className, ...otherProps }: IconProps) => {
  const { addThemeClassName } = useFusionTheme();

  return (
    <IconComponent
      className={addThemeClassName(iconVariants({ size }), className)}
      {...otherProps}
    />
  );
};

export default Icon;
